import type { TasksSlice } from '../bs/tasks'

/**
 * English for the tasks screens.
 *
 * Complete, not partial — see en/index.ts. "Report" for *prijava* throughout,
 * because the thing a worker files about a machine is a report and calling it
 * a "submission" only makes sense to whoever wrote the database column.
 */
export const tasks: TasksSlice = {
  'tasks.help':
    'Press “{start}” when you begin work on a task and “{done}” when you finish it, so your supervisor knows how far it has got. A task past its deadline shows in red on the home screen.',

  'tasks.title': 'My tasks',
  'tasks.subtitle.openOnly': 'Unfinished tasks',
  'tasks.subtitle.all': 'All tasks',
  'tasks.filter.showAll': 'Show all',
  'tasks.filter.openOnly': 'Unfinished only',

  'tasks.overdue.one': 'One task is overdue.',
  'tasks.overdue.many': '{count} tasks are overdue.',

  'tasks.empty.openTitle': 'You have no open tasks',
  'tasks.empty.allTitle': 'You have no tasks',
  'tasks.empty.manager':
    'These are the tasks assigned to you. A task always belongs to a report — assign one with the “New task” button, or from the report itself.',
  'tasks.empty.worker': 'Tasks are assigned by your supervisor, from the report they came from.',

  'tasks.card.due': 'Due: {date}',
  'tasks.card.noDue': 'No deadline',
  'tasks.card.openSubmission': 'open the report',
  'tasks.card.overdue': 'Overdue',
  'tasks.action.start': 'Start',
  'tasks.action.markDone': 'Mark as done',
  'tasks.updated': 'Task updated.',
  'tasks.updateFailed': 'That could not be updated.',

  'tasks.new': 'New task',
  'tasks.new.cancel': 'Cancel',
  'tasks.new.submit': 'Assign task',
  'tasks.new.submission': 'Report',
  'tasks.new.submission.hint':
    'A task is always tied to a report. Only open reports are listed.',
  'tasks.new.submission.placeholder': 'Choose a report',
  'tasks.new.submission.none':
    'No open reports. A task is assigned against a report, so one has to be filed first.',
  'tasks.new.title': 'Task',
  'tasks.new.title.placeholder': 'e.g. Replace the bearing on the planer',
  'tasks.new.assignee': 'Assigned to',
  'tasks.new.assignee.placeholder': 'Choose a person',
  'tasks.new.description': 'Description',
  'tasks.new.description.placeholder':
    'Optional — what exactly needs doing, and which parts are needed.',
  'tasks.new.dueDate': 'Deadline',
  'tasks.new.dueDate.hint': 'It cannot be in the past.',
  'tasks.new.assigned': 'Task assigned.',
  'tasks.new.failed': 'That could not be assigned.',

  'tasks.scan.title': 'Scan a QR code',
  'tasks.scan.subtitle':
    'Point the camera at the sticker on the machine. The report opens with the work centre already chosen.',
  'tasks.scan.searching': 'Looking for a QR code…',
  'tasks.scan.errorTitle': 'Scanning is not possible',
  'tasks.scan.unknownCode':
    'That QR code was not recognised. Ask your supervisor for a new sticker.',
  'tasks.scan.cameraBlocked':
    'No access to the camera. Allow the camera in your browser settings, or choose the work centre by hand.',
  'tasks.scan.pickManually': 'Choose the work centre by hand',

  'tasks.qr.checkingSession': 'Checking your session…',
  'tasks.qr.opening': 'Opening the work centre…',
  'tasks.qr.unknownTitle': 'Unknown QR code',
  'tasks.qr.unknownCode':
    'That QR code was not recognised. The sticker may have been replaced — tell your supervisor.',

  'tasks.scanner.starting': 'Starting the camera…',
  'tasks.scanner.cameraBlocked':
    'No access to the camera. Allow the camera in your browser settings.',

  'tasks.qr.otherPlantTitle': 'Machine not in your plants',
  'tasks.qr.otherPlant':
    'This machine is not in any of the plants you have access to — or the sticker is no longer valid. If you need to report something on it, ask your administrator.',
}
